import { Box, InputLabel, TextField } from "@mui/material";
import styles from './FormInput.module.scss';
import classNames from 'classnames/bind';
import { getUnit } from "@mui/material/styles/cssUtils";
import { getIn } from "formik";

const cx = classNames.bind(styles);

const FormInput = (props: {
  name: string;
  text: string;
  form?: any;
  placeholder: string;
  inputkey: string;
  value?: string | number | null;
  disable?: boolean;
  inputType?: string;
  maxText?: number;
  unit?: string;
  onChange?: (e: any) => void;
  width?: string;
  restrictNumber?: boolean; 
  height?:string;
  isViewMode?:boolean;
  isViewNoInput?:boolean;
  error?:string;
}) => {
  const {
    name,
    text,
    form,
    placeholder,
    inputkey,
    value,
    inputType = "text",
    maxText,
    unit,
    onChange,
    disable,
    width,
    restrictNumber, 
    height,
    isViewMode,
    isViewNoInput,
    error,

  } = props;
    

  const errorMessage = error ? error : getIn(form?.errors, inputkey);
  const getUnit = (unit:string) =>{

    return unit
  }
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    let updatedValue = inputValue;

    if (restrictNumber) {
      updatedValue = inputValue.replace(/[^0-9]/g, "");
    }

    if (onChange) {
      onChange({ ...e, target: { ...e.target, value: updatedValue } });
    }

    if (form) {
      form.setFieldValue(inputkey, updatedValue);
    }
  };

  return (
    <Box className="w-full">
      {text && <InputLabel className={cx("form-input-title")}>{text}</InputLabel>}

      {
        isViewMode ? <>
          <div className={cx({
            "box-view":true,
            "box-textarea-view": inputType === "textarea",
          })} style={{
            height: height? height +" !important" : inputType === "textarea" ?  "150px" : "50px",
            minHeight: height ? height : inputType === "textarea" ?  "150px" : "50px",
            background: isViewNoInput? "transparent":undefined,
            border: isViewNoInput? "0px":undefined,
            paddingLeft: isViewNoInput? "0px":undefined,
          }}>
            {value}
          </div>
        </> : <Box
        className={cx({
          "box-form-input": true,
          "box-form-input-unit": unit,
        })}
        style={{
          width: width,
        }}
      >
        <TextField
          className={cx({
            "form-input": true,
            "form-textarea": inputType === "textarea",
          })}
          fullWidth
          type={inputType}
          multiline={inputType=="textarea"}
          name={name}
          placeholder={placeholder}
          value={value !== undefined ? value : form?.values[inputkey]}
          onChange={handleInputChange}
          disabled={disable}
          error={Boolean(errorMessage)}
          helperText={errorMessage}
          sx={{
            "& .MuiInputBase-root": {
              minHeight: height ? height : "50px",
            },
            "& .MuiInputBase-root.MuiInputBase-multiline": {
              minHeight: height ? height : "150px",
              height: height ? height : "150px",
            }
            
          }}
        />
        {unit && getUnit(unit)}
      </Box>
      }
      
    </Box>
  );
};

export default FormInput;
